import { resultsRating } from '../helpers/results-helper';
import googleMaps from '../helpers/google-maps';
import _ from 'underscore'

document.addEventListener('turbolinks:load', function() {
  calculateScaleMarkerPosition();

  const body = $('body');
  if (body.data('controller') !== 'results' || body.data('action') !== 'show') return;

  pageBootstrap();
});

let expandAction = () => {
  let statusDiv = $('.semi-static-status');
  if (statusDiv.length === 0) return;

  let analyteId = statusDiv.data('analyteId')
  let collapsible = $(`#test-${analyteId}`)
  statusDiv.on('click', function() {
    collapsible.collapse('toggle');
    statusDiv.attr('aria-expanded', !JSON.parse(statusDiv.attr('aria-expanded')));
  });
}

let mapsInitialize = () => {
  let modal = $('#specialist-lookup');
  let specialistForm = $('#specialist-lookup-form');
  let specialistListContainer = $('#specialist-list-container');
  let mapsCommon = googleMaps
    .initialize(
      specialistForm,
      specialistListContainer,
      'specialist_lookup'
    );
  mapsCommon.createMap();
}

let findSpecialist = () => {
  $('#find-specialist-btn').on('click', mapsInitialize);
}

let pageBootstrap = () => {
  expandAction();
  resultsRating(pageBootstrap);
  findSpecialist();
};

const calculateScaleMarkerPosition = () => {
  const markers = document.querySelectorAll('[data-js-scaler-marker]')

  markers.forEach(marker => {
    const clonedMarker = marker.cloneNode(true);
    const currentLeft = marker.style.left

    document.body.appendChild(clonedMarker)

    marker.style.setProperty('left', `calc(${currentLeft} - ${clonedMarker.offsetWidth/2}px)`)

    clonedMarker.remove()
  })
}
